// Frontend analytics helpers for canonical content.
// Analytics helpers for shared document-system interactions.

import type { Document } from '@airhead-games/shared/content';
import { analyticsService } from '../../services/analyticsService';

export const trackDocumentShare = (document: Document, channel: string) => {
  const eventName =
    document.kind === 'blog' ? `Share ${channel}` : 'Document Share';

  analyticsService.trackButtonClick(eventName, {
    link_location: document.kind === 'blog' ? 'blog_share' : 'document_share',
    post_slug: document.kind === 'blog' ? document.slug : undefined,
    document_id: document.id,
    share_channel: channel,
  });
};
